import React from 'react';

import { ERoles } from './constants';

import RequestReservationCard from './RequestReservationCard';

function RequestReservationCardContainerAO() {
	return <RequestReservationCard role={ERoles.ao} />;
}

export default RequestReservationCardContainerAO;
